<template>
  <div>
    <Breadcrumb
      :name=" $t('profile.send_password_reset')"
      :id="user.id"
      :showBackButton="true"
      @backButtonPressed="clickBack"
    >
      <template v-slot:icon>
        <MapIcon color="red" :size="39"/>
      </template>
    </Breadcrumb>
    <CollapsePanel
      :title="$t('profile.user')"
      :loading=loading
      :showCount=false
      :collapsed="true"
      :disabled="false"
      :showCollapseAction="false"
      icon="pen"
    >
      <div class="content-padding" v-if="user">
        <label for="input-field-email"> {{ $t('profile.email') | capitalize }} </label>
        <div id="input-field-email" class="field">
          <input
            id="email"
            name="email"
            type="text"
            v-model="user.email"
          />
        </div>
      </div>
      <div class="edit-object-buttons">
        <a class="btn grey" @click="clickBack">
          {{ $t('button.cancel') | capitalize }}
        </a>
        <a class="btn save-button" @click="sendMail">
          {{ $t('profile.sendmail') | capitalize }}
        </a>
      </div>
    </CollapsePanel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Layout/Breadcrumb.vue';
import CollapsePanel from '@/components/CollapsePanel.vue';
import UserApi from '@/api/user';
import MapIcon from '@/components/Map/MapIcon.vue';

export default {
  name: 'profile',
  components: {
    Breadcrumb,
    CollapsePanel,
    MapIcon,
  },
  computed: {
    ...mapGetters({
      network: 'settings/getNetworkModel',
    }),
  },
  data() {
    return {
      user: [],
      loading: false,
      data: Object,
    };
  },
  methods: {
    clickBack() {
      this.$router.push({
        name: 'profile',
      });
    },
    sendMail() {
      this.data = {
        name: this.user.name,
        email: this.user.email,
      };
      UserApi.sendPasswordRequestMail(this.data);
      this.$router.push({
        name: 'profile',
      });
    },
    toggleShowCollapseMenu() {
      this.showCollapseMenu = !this.showCollapseMenu;
    },
  },
  beforeCreate() {
    UserApi.getMe().then((response) => {
      this.user = response.data;
    });
  },
};
</script>
<style>
.location-details li span{
  display: block;
  float: left;
  width: 40%;
}
.edit-object-buttons {
  padding: 10px 20px;
  position: relative;
  background: #f2f7fe;
  min-height: 50px;
  border-bottom: 1px solid #d9dadb;
}

.edit-object-buttons .save-button {
  float: right;
  margin-right: 7px;
}
.location-details {
  font-size:16px;
}
</style>
